/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardGrant } from './RewardGrant';
import {
    RewardGrantFromJSON,
    RewardGrantFromJSONTyped,
    RewardGrantToJSON,
    RewardGrantToJSONTyped,
} from './RewardGrant';
import type { LevelEmailOverride } from './LevelEmailOverride';
import {
    LevelEmailOverrideFromJSON,
    LevelEmailOverrideFromJSONTyped,
    LevelEmailOverrideToJSON,
    LevelEmailOverrideToJSONTyped,
} from './LevelEmailOverride';
import type { AssetResponse } from './AssetResponse';
import {
    AssetResponseFromJSON,
    AssetResponseFromJSONTyped,
    AssetResponseToJSON,
    AssetResponseToJSONTyped,
} from './AssetResponse';
import type { LevelGate } from './LevelGate';
import {
    LevelGateFromJSON,
    LevelGateFromJSONTyped,
    LevelGateToJSON,
    LevelGateToJSONTyped,
} from './LevelGate';
import type { LevelGateOperator } from './LevelGateOperator';
import {
    LevelGateOperatorFromJSON,
    LevelGateOperatorFromJSONTyped,
    LevelGateOperatorToJSON,
    LevelGateOperatorToJSONTyped,
} from './LevelGateOperator';

/**
 * 
 * @export
 * @interface LevelConfigResponse
 */
export interface LevelConfigResponse {
    /**
     * 
     * @type {string}
     * @memberof LevelConfigResponse
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof LevelConfigResponse
     */
    level: number;
    /**
     * 
     * @type {number}
     * @memberof LevelConfigResponse
     */
    sortOrder: number;
    /**
     * XP earned at this level required to advance to the next level (per-level delta, not cumulative)
     * @type {number}
     * @memberof LevelConfigResponse
     */
    xpRequired: number;
    /**
     * 
     * @type {boolean}
     * @memberof LevelConfigResponse
     */
    isActive: boolean;
    /**
     * 
     * @type {Array<LevelGate>}
     * @memberof LevelConfigResponse
     */
    gates: Array<LevelGate>;
    /**
     * 
     * @type {LevelGateOperator}
     * @memberof LevelConfigResponse
     */
    gateOperator: LevelGateOperator;
    /**
     * 
     * @type {Array<string>}
     * @memberof LevelConfigResponse
     */
    rewardConfigIds: Array<string>;
    /**
     * Catalog-item grants (reward-catalog Option B) — additive alongside rewardConfigIds during the migration.
     * @type {Array<RewardGrant>}
     * @memberof LevelConfigResponse
     */
    rewardGrants?: Array<RewardGrant>;
    /**
     * 
     * @type {string}
     * @memberof LevelConfigResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LevelConfigResponse
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof LevelConfigResponse
     */
    imageAssetId?: string;
    /**
     * 
     * @type {AssetResponse}
     * @memberof LevelConfigResponse
     */
    imageAsset?: AssetResponse;
    /**
     * 
     * @type {LevelEmailOverride}
     * @memberof LevelConfigResponse
     */
    emailOverride?: LevelEmailOverride;
    /**
     * 
     * @type {boolean}
     * @memberof LevelConfigResponse
     */
    shouldSendLevelUpEmail: boolean;
    /**
     * Dollar amount of FUEL tokens awarded when reaching this level
     * @type {number}
     * @memberof LevelConfigResponse
     */
    fuelBonusAmount?: number;
    /**
     * Hex color (e.g. "#F1161D") for this level's tier accent in the level-up modal/email. Defaults to a per-band palette when unset.
     * @type {string}
     * @memberof LevelConfigResponse
     */
    accentColor?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LevelConfigResponse
     */
    shouldNotifyAdmin: boolean;
    /**
     * 
     * @type {number}
     * @memberof LevelConfigResponse
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof LevelConfigResponse
     */
    updatedAt: number;
}



/**
 * Check if a given object implements the LevelConfigResponse interface.
 */
export function instanceOfLevelConfigResponse(value: object): value is LevelConfigResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('level' in value) || value['level'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    if (!('xpRequired' in value) || value['xpRequired'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('gates' in value) || value['gates'] === undefined) return false;
    if (!('gateOperator' in value) || value['gateOperator'] === undefined) return false;
    if (!('rewardConfigIds' in value) || value['rewardConfigIds'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('shouldSendLevelUpEmail' in value) || value['shouldSendLevelUpEmail'] === undefined) return false;
    if (!('shouldNotifyAdmin' in value) || value['shouldNotifyAdmin'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function LevelConfigResponseFromJSON(json: any): LevelConfigResponse {
    return LevelConfigResponseFromJSONTyped(json, false);
}

export function LevelConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LevelConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'level': json['level'],
        'sortOrder': json['sortOrder'],
        'xpRequired': json['xpRequired'],
        'isActive': json['isActive'],
        'gates': ((json['gates'] as Array<any>).map(LevelGateFromJSON)),
        'gateOperator': LevelGateOperatorFromJSON(json['gateOperator']),
        'rewardConfigIds': json['rewardConfigIds'],
        'rewardGrants': json['rewardGrants'] == null ? undefined : ((json['rewardGrants'] as Array<any>).map(RewardGrantFromJSON)),
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'imageAssetId': json['imageAssetId'] == null ? undefined : json['imageAssetId'],
        'imageAsset': json['imageAsset'] == null ? undefined : AssetResponseFromJSON(json['imageAsset']),
        'emailOverride': json['emailOverride'] == null ? undefined : LevelEmailOverrideFromJSON(json['emailOverride']),
        'shouldSendLevelUpEmail': json['shouldSendLevelUpEmail'],
        'fuelBonusAmount': json['fuelBonusAmount'] == null ? undefined : json['fuelBonusAmount'],
        'accentColor': json['accentColor'] == null ? undefined : json['accentColor'],
        'shouldNotifyAdmin': json['shouldNotifyAdmin'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function LevelConfigResponseToJSON(json: any): LevelConfigResponse {
    return LevelConfigResponseToJSONTyped(json, false);
}

export function LevelConfigResponseToJSONTyped(value?: LevelConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'level': value['level'],
        'sortOrder': value['sortOrder'],
        'xpRequired': value['xpRequired'],
        'isActive': value['isActive'],
        'gates': ((value['gates'] as Array<any>).map(LevelGateToJSON)),
        'gateOperator': LevelGateOperatorToJSON(value['gateOperator']),
        'rewardConfigIds': value['rewardConfigIds'],
        'rewardGrants': value['rewardGrants'] == null ? undefined : ((value['rewardGrants'] as Array<any>).map(RewardGrantToJSON)),
        'name': value['name'],
        'description': value['description'],
        'imageAssetId': value['imageAssetId'],
        'imageAsset': AssetResponseToJSON(value['imageAsset']),
        'emailOverride': LevelEmailOverrideToJSON(value['emailOverride']),
        'shouldSendLevelUpEmail': value['shouldSendLevelUpEmail'],
        'fuelBonusAmount': value['fuelBonusAmount'],
        'accentColor': value['accentColor'],
        'shouldNotifyAdmin': value['shouldNotifyAdmin'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

